export default __webpack_public_path__ + "static/media/stack_logos-node.26c87898.jpg";